import { forwardRef, useImperativeHandle, useState } from 'react';

import AddProductsDialogContent from './AddProductsDialogContent';
import AddProductsDialogHeader from './AddProductsDialogHeader';

import {
    Dialog,
    Slide,
    SxProps,
    Theme,
    useMediaQuery,
    useTheme,
} from '@mui/material';

import type { TransitionProps } from '@mui/material/transitions';
import RefundLineItem from '../../../models/RefundLineItem';

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export interface AddProductsDialogHandle {
    open: VoidFunction;
    close: VoidFunction;
}

interface AddProductsDialogProps {
    onSubmit: (items: RefundLineItem[]) => void;
}

const AddProductsDialog = forwardRef<
    AddProductsDialogHandle,
    AddProductsDialogProps
>((props, ref) => {
    const { onSubmit } = props;

    const theme = useTheme();

    const small = useMediaQuery(theme.breakpoints.down('sm'));

    const [isOpen, setOpen] = useState<boolean>(false);

    const handleClose = (): void => {
        setOpen(false);
    };

    const dialogStyle: SxProps<Theme> = {
        marginTop: small ? 2 : undefined,
    };

    useImperativeHandle(
        ref,
        () => ({
            open: setOpen.bind(this, true),
            close: handleClose,
        }),
        []
    );

    return (
        <Dialog
            fullScreen={small}
            TransitionComponent={small ? Transition : undefined}
            open={isOpen}
            onClose={handleClose}
            sx={dialogStyle}
            maxWidth={'md'}
            fullWidth
        >
            <AddProductsDialogHeader onClose={handleClose} />

            <AddProductsDialogContent onSubmit={onSubmit} />
        </Dialog>
    );
});

AddProductsDialog.displayName = 'AddProductsDialog';

export default AddProductsDialog;
